module.exports = __webpack_public_path__ + "9fc90379bcd0b29f90245230a5b908bb.png";